/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_TitleInputs */

const en_mobile_referral_title = /** @type {(inputs: Mobile_Referral_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral Code`)
};

const es_mobile_referral_title = /** @type {(inputs: Mobile_Referral_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de referido`)
};

/**
* | output |
* | --- |
* | "Referral Code" |
*
* @param {Mobile_Referral_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_title = /** @type {((inputs?: Mobile_Referral_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_title(inputs)
	return en_mobile_referral_title(inputs)
});